import ExamComponent from './components/ExamComponent.vue'
import { store } from './stores'

export default {
  elementId: 'exam_box',
  rootComponent: ExamComponent,
  stores: [
    {
      key: ['Exam'],
      module: store
    }
  ]
}
